import {
    DOCUMENT_EXT_CSV,
    DOCUMENT_EXT_XLS,
    DOCUMENT_EXT_XLSX,
} from './document-file.constants';
import { pickDocumentExtension } from './document-file-extension.util';

export const SpreadsheetMime = {
    Csv: 'text/csv',
    ExcelOpenXml:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ExcelLegacy: 'application/vnd.ms-excel',
} as const;

export type CsvOrExcelOpenXmlMime =
    | typeof SpreadsheetMime.Csv
    | typeof SpreadsheetMime.ExcelOpenXml;

export function spreadsheetExportAcceptHeader(
    exportType: string
): CsvOrExcelOpenXmlMime {
    const type = exportType?.toLowerCase() ?? '';
    return type.includes('xls') || type.includes('excel')
        ? SpreadsheetMime.ExcelOpenXml
        : SpreadsheetMime.Csv;
}

export const SPREADSHEET_UPLOAD_FILE_EXTENSIONS = [
    pickDocumentExtension(DOCUMENT_EXT_CSV),
    pickDocumentExtension(DOCUMENT_EXT_XLS),
    pickDocumentExtension(DOCUMENT_EXT_XLSX),
] as const;

export const SPREADSHEET_FILE_ACCEPT = [
    ...SPREADSHEET_UPLOAD_FILE_EXTENSIONS,
    SpreadsheetMime.ExcelOpenXml,
    SpreadsheetMime.ExcelLegacy,
].join(', ');
